const featuresPay = {
    featureTitle: 'Podejmuj decyzje biznesowe oparte na danych',
    featureDescription:
        'Sprawdź, które produkty sprzedają się najlepiej i generują największy zysk. Uzyskaj dostęp do raportów finansowych kiedykolwiek i gdziekolwiek. Twoje biznes w zasięgu ręki!',
    featureButton: 'Subskrypcja Premium',
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'Już od',
    featureEndingText: 'tys.',

    features: [
        {
            title: 'Nieograniczona liczba produktów',
            description: 'Dodawaj wszystkie produkty bez żadnych limitów.'
        },
        {
            title: 'Nieograniczona liczba pracowników',
            description: 'Dodawaj pracowników/administratorów do firmy bez żadnych limitów.'
        },
        {
            title: 'Nieograniczona historia',
            description: 'Przeglądaj zmiany w starych rekordach magazynowych bez ograniczeń.'
        },
        {
            title: 'Filtr historii',
            description: 'Łatwo przeglądaj historię według typu, kategorii, pracownika i daty.'
        },
        {
            title: 'Pobierz do Excela',
            description: 'Pobierz historię rekordów magazynowych do Microsoft Excel jednym kliknięciem.'
        },
        {
            title: 'Pobierz do PDF',
            description: 'Pobierz aktualną listę produktów i stanów magazynowych do PDF jednym kliknięciem.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Twórz wiele magazynów, aby lepiej zarządzać stanami.'
        },
        {
            desc: 'Przypisuj produkty do konkretnych lokalizacji.'
        },
        {
            desc: 'Monitoruj poziomy zapasów w różnych magazynach.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Dodawaj warianty rozmiaru, koloru lub materiału.' },
        { desc: 'Ustawiaj poziomy zapasów dla każdego wariantu.' },
        { desc: 'Śledź stany w różnych magazynach.' }
    ]
}

export default featuresPay